function UserService(ApiService) {
  'ngInject';

  const service = {};

  service.listOrganizations = function(url,callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.organizations =  function(default_id, callbackFunc){
    ApiService.get(`/organizations.json?default_id=${default_id}`, callbackFunc);
  };

  service.startPendingJobs = function(orgId,type,callbackFunc) {
    ApiService.get(`/organizations/${orgId}/${type}/try_job`, callbackFunc);
  };

  service.showAmazonPendingJob = function(orgId, callbackFunc){
    ApiService.get(`/organizations/${orgId}/amazon_journals/pending_job_count`, callbackFunc);
  };

  service.showBulkPendingJob = function(orgId, callbackFunc){
    ApiService.get(`/organizations/${orgId}/bulk_cost_journals/pending_job_count`, callbackFunc);
  };

  service.showShopifyPendingJob = function(orgId, callbackFunc){
    ApiService.get(`/organizations/${orgId}/shopify_invoices/pending_job_count`, callbackFunc);
  };

  service.showReportsPendingJob = function(orgId, callbackFunc){
    ApiService.get(`/organizations/${orgId}/reports/pending_job_count`, callbackFunc);
  };


  service.getOrganizationArray = function(data){
    let organizations  = [];
    let index = data.organizations.map(function(d){
      return d.organization.id;
    })
    if(data.default_organization &&  index == -1){
      organizations.push(data.default_organization);
    }
    data.organizations.forEach(function(d){
      organizations.push(d.organization);
    });
    return organizations;
  };

  return service;
}

export default {
  name: 'UserService',
  fn: UserService
};
